export enum EventType {
  BackgroundTapPressed = 'talk-viewer/event/BackgroundTapPressed',
  BackgroundLongTapPressed = 'talk-viewer/event/BackgroundLongTapPressed',
  TalkTapPressed = 'talk-viewer/event/TalkTapPressed',
  TalkLongTapPressed = 'talk-viewer/event/TalkLongTapPressed',
  ViewerSwipedUp = 'talk-viewer/event/ViewerSwipedUp',
  ViewerSwipedDown = 'talk-viewer/event/ViewerSwipedDown',
  ViewerPaused = 'talk-viewer/event/ViewerPaused',
  ViewerPulledDown = 'talk-viewer/event/ViewerPulledDown',
  ViewerPulledUp = 'talk-viewer/event/ViewerPulledUp',
  EndOfTalkReached = 'talk-viewer/event/EndOfTalkReached',
  TutorialTapPressed = 'talk-viewer/event/TutorialTapPressed',
  ReplayBoxTapPressed = 'talk-viewer/event/ReplayBoxTapPressed',
  AutoTapChangeStatusTapPressed = 'talk-viewer/event/AutoTapChangeStatusTapPressed',
  AutoTapChangeSpeedTapPressed = 'talk-viewer/event/AutoTapChangeSpeedTapPressed',
  ProductExposedAreaChanged = 'talk-viewer/event/ProductExposedAreaChanged',
  MutedToggleTapPresssed = 'talk-viewer/event/MutedToggleTapPresssed',
  MediaEnded = 'talk-viewer/event/MediaEnded',
  FullscreenHideRequested = 'talk-viewer/event/FullscreenHideRequested',
  ViewingModeToggleTapPressed = 'talk-viewer/event/ViewingModeToggleTapPressed',
  ViewerMenuExposedToggleTapPressed = 'talk-viewer/event/ViewerMenuExposedToggleTapPressed',
  FullscreenImageTapPressed = 'talk-viewer/event/FullscreenImageTapPressed',
  LeaveAndMoveOnToTheNextTrigerred = 'talk-viewer/event/LeaveAndMoveOnToTheNextTrigerred',
  ForceProcessToTalkId = 'talk-viewer/event/ForceProcessToTalkId',
  ForceProcessToTalkGroupId = 'talk-viewer/event/ForceProcessToTalkGroupId',
  ForceProcessToSceneId = 'talk-viewer/event/ForceProcessToSceneId',
}
